import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import requests from './services/requests'

class EventRoute extends Component {
  state = {
    event: null,
    loading: true,
  }
  async componentWillMount() {
    try {
      const { eventId } = this.props.computedMatch.params
      const event = await requests.get(`/event/${eventId}`)
      this.setState({ event, loading: false })
    } catch (err) {
      console.error(err)
      this.setState({ loading: false })
    }
  }
  render() {
    const { loading, event } = this.state
    const { component: RouteComponent, ...rest } = this.props
    if (loading) {
      return (
        <div>Loading</div>
      )
    }
    return (
      <Route
        {...rest}
        render={props =>
          (event ? (<RouteComponent event={event} {...props} />) : (<Redirect to={{ pathname: '/' }} />))
        }
      />
    )
  }
}
EventRoute.propTypes = {
  component: PropTypes.func.isRequired,
  computedMatch: PropTypes.shape({
    params: PropTypes.shape({
      eventId: PropTypes.string.isRequired,
    }).isRequired,
  }),
}
EventRoute.defaultProps = {
  computedMatch: {
    params: {
      eventId: '',
    },
  },
}

export default EventRoute



// WEBPACK FOOTER //
// ./src/EventRoute.js